var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 377,
    height: 172,
    viewBox: "0 0 377 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M377 97.1295C372.152 97.2721 367.29 97.7953 362.442 97.4624C357.479 97.1295 353.672 100.792 350.46 107.474C345.282 118.27 341.208 130.564 337.007 142.667C334.29 150.515 331.371 158.005 327.424 163.855C321.293 172.963 314.668 174.437 307.548 168.254C301.785 163.261 297.203 155.342 292.71 147.233C290.197 142.691 287.748 138.078 285.006 133.988C278.685 124.571 271.717 121.504 263.911 125.903C260.688 127.71 257.464 129.565 254.227 131.348C246.904 135.391 239.999 133.346 233.564 125.927C231.229 123.239 228.817 120.457 226.939 116.795C219.679 102.741 210.553 98.9605 200.628 98.9605C141.202 98.9605 0.152416 98.9605 0.152416 98.9605L0 0H377V97.1295Z",
    fill: "#FFBC0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrip);
export default __webpack_public_path__ + "static/media/drip.6f57c6c97e2f33741e258584b9d1e6cd.svg";
export { ForwardRef as ReactComponent };